"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseMediabyIdSchema = void 0;
var _zod = require("zod");
var _OlapicResponseMediaItem = require("./OlapicResponseMediaItem");
const olapicResponseMediabyIdSchema = exports.olapicResponseMediabyIdSchema = _zod.z.object({
  data: _OlapicResponseMediaItem.olapicMediaItemSchema
});
